GatorSurvey.app.directive('gsSurveyLiveReviewElement', SurveyLiveReviewElement);

function SurveyLiveReviewElement() {
    return {
        require: '?ngModel',
        restrict: 'AE',
        scope: {
            element: "=ngModel",
            pageId: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/LiveReview/Templates/SurveyLiveReviewElement.html',
        controller: [
            '$scope', '$q','$sce', function ($scope, $q, $sce) {
                $scope.deliberatelyTrustDangerousSnippet = function (item) {
                    return $sce.trustAsHtml(item);
                };
            }
        ]
    };
}
